<template>
  <div>
    <video
      id="my_video"
      class="video-js vjs-default-skin"
      controls
      autoplay
      preload="auto"
      style="width:100%;height:100%"
      data-setup="{}"
    >
      <source :src="source" type="application/x-mpegURL" />
    </video>
  </div>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
import "video.js/dist/video-js.css";
export default {
  props: {
    source: String,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    var video = videojs("my_video");
    video.play();
  },
  methods: {},
};
</script>

<style lang="less" scoped>
</style>